/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql } from '@apollo/client';
import { apolloClient } from 'apolloClient/apolloClient';

export const extractFieldPath = (field: string): string => {
  const fieldPattern = /^\[(.*?)\]$/;
  return fieldPattern.test(field) ? field.replace(fieldPattern, '$1') : field;
};

export const callGqlMutation = <R>(mutation: any, variables: any, callback: (result: any) => R): Promise<R> =>
  apolloClient
    .mutate({
      mutation: mutation,
      variables: variables,
    })
    .then(callback);

export const callGqlQuery = <R>(query: any, variables: any, callback: (result: any) => R): Promise<R> =>
  apolloClient
    .query({
      fetchPolicy: 'no-cache',
      query: query,
      variables: variables,
    })
    .then(callback);

export const callGql = <R>(gqlString: any, variables: any, callback: (result: any) => R): Promise<R> => {
  switch (gqlString.definitions[0].operation) {
    case 'query':
      return callGqlQuery(gqlString, variables, callback);
    case 'mutation':
      return callGqlMutation(gqlString, variables, callback);
    default:
      throw new Error('Unsupported operation');
  }
};

export const buildGql = (
  queryType: 'query' | 'mutation',
  methodName: string,
  paramTypes: Record<string, string>,
  returnFragment: string,
): any => {
  const signature = Object.entries(paramTypes)
    .map(([p, t]) => `\$${p}: ${t}`)
    .join(', ');
  const args = Object.entries(paramTypes)
    .map(([p]) => `${p}: \$${p}`)
    .join(', ');
  const query = `
      ${queryType} (${signature}) {
          ${methodName}(${args}) ${returnFragment}
      }
      `;
  return gql`
    ${query}
  `;
};

export const callApi = <R>(
  queryType: 'query' | 'mutation',
  methodName: string,
  paramTypes: Record<string, string>,
  variables: any,
  returnFragment: string,
  callback: (result: any) => R,
): Promise<R> => {
  const query = buildGql(queryType, methodName, paramTypes, returnFragment);
  return callGql(query, variables, callback);
};
